<section class="hero-section overflow-hidden mt-5">
  <div class="flex z-10 absolute top-1/2 -translate-y-1/2 left-0 right-0 w-full">
    <div class="mx-auto container flex">
      <div class="w-full md:w-1/2 flex flex-col gap-y-10 px-4 lg:px-0">
        <h1 class="heading">
          Trust
          <br />
          checker
        </h1>
      </div>
    </div>
  </div>
</section>
